module.exports = __webpack_public_path__ + "static/communitycaretx-3e882e73f96b88853aceb17aa75b3047.jpg";